import styles from "./SideSheet.module.css";
import SideSheetTop from "./SideSheetTop";
import SideSheetHandle from "./SideSheetHandle";
import { Dispatch, SetStateAction } from "react";
import { CategoryOptions, MapInfo } from "../../common/Common";

interface SideSheetProps {
    mapInfo: MapInfo;
    categories: CategoryOptions[];
    selectedCategory: number;
    setSelectedCategory: Dispatch<SetStateAction<number>>;
    children: JSX.Element;
    shouldFloatingRender: boolean
    showSideSheet: boolean
    shouldSideRender: boolean
    setShowSideSheet: Dispatch<SetStateAction<boolean>>;
    isMobileView?: boolean;

    // 25.07.17 | Kim Young Jun | 사이드 시트 닫힘 상태 추가
    isClosedSideSheet: boolean;
    setIsClosedSideSheet: Dispatch<SetStateAction<boolean>>;
}

/**
 * @author cwlee, mjkang
 * @date 2024-09-03 10:52:48
 * @remark 사이드 시트
 * @param SideSheetProps
 * @returns
 */
const SideSheet = (props: SideSheetProps) => {
    return (
        <div className={styles.container}>
            <div className={`${styles.wrapper}`}>
                <SideSheetTop title={props.mapInfo.title} keywords={props.mapInfo.keyword as string[]} />
                <div className={styles.content}>{props.children}</div>
            </div>
            {!props.shouldFloatingRender && (<SideSheetHandle
                shouldSideRender={props.shouldSideRender}
                showSideSheet={props.showSideSheet}
                setShowSideSheet={props.setShowSideSheet}
                // 25.07.17 | Kim Young Jun | 사이드 시트 닫힘 상태 추가
                isClosedSideSheet={props.isClosedSideSheet}
                setIsClosedSideSheet={props.setIsClosedSideSheet}
            />)}
        </div>
    );
};

export default SideSheet;
